<template>
  <generic-container
    icon="poll"
    :title="$t('survey templates')"
    :configurable="true"
    :show_plus="true"
    v-bind:configure_modal="configure_modal"
    @add="add"
    :show_refresh="true"
    @refresh="init"
    :header_buttons="header_buttons"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("survey name") }}</th>
          <th>{{ $t("questions") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <survey-template-modal
      ref="survey_template_modal"
      @success="init"
      :module_configuration="module_configuration"
    />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import {
  // local_api,
  init_ajax_data_datables,
  enterprise_setup,
  // error_toast,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import SurveyTemplateModal from "./survey_template_modal/Index.vue";

// @ is an alias to /src
export default {
  name: "OnfidoConnectIndex",
  components: {
    "generic-container": GenericContainer,
    SurveyTemplateModal,
  },
  filters: filters,
  data() {
    return {
      configure_modal: ConfigureModal,
      datatable: {},
      header_buttons: [
        // {
        //   icon: "cubes",
        //   click: this.go_bulk,
        //   tooltip: this.$t("bulk process"),
        // },
      ],
      module_configuration: {
        configuration: {},
        social_networks: [],
      },
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      let vm = this;
      vm.$refs.survey_template_modal.show_modal();
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function(row) {
            return filters.formatDate(
              row.create_date,
              vm.enterprise_setup.detailed_date_format,
            );
          },
        },
        {
          data: function(row) {
            return row.name;
          },
        },
        {
          data: function(row) {
            return row.setup.questions.length;
            // return `<pre>${JSON.stringify(row.setup, null, 2)}</pre>`;
          },
        },
      ];
      let onSelect = (data) => {
        vm.$refs.survey_template_modal.show_modal(data);
      };
      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["survey template url"],
        columns,
        onSelect,
      );
    },
    // load_configuration() {
    //   return new Promise((resolve, reject) => {
    //     let vm = this;
    //     local_api(vm, "post", "/visalink/configuration/do-get")
    //       .then((conf) => {
    //         if (conf) {
    //           vm.module_configuration.configuration = conf;
    //           resolve(conf);
    //         }
    //       })
    //       .catch((err) => {
    //         error_toast(err);
    //         reject(err);
    //       });
    //   });
    // },
  },
  created() {},
  mounted() {
    let vm = this;
    // vm.load_configuration()
    //   .then(() => {
    vm.init();
    // })
    // .catch((err) => {
    //   console.error(err);
    // });
  },
  watch: {},
};
</script>
